/**
 * The stored answer key of a spelling bee: one pangram, the proof that the hive has one.
 * Kept apart from the editor component so the eagerly loaded module never pulls the form in.
 */
import type { SpellingBeeDefinition, SpellingBeeSolution } from "./types";

export type { SpellingBeeSolution };

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function emptySolution(_definition: SpellingBeeDefinition): SpellingBeeSolution {
  return { pangram: "" };
}

/** Reads whatever is stored, however wrong, and keeps the string it can use. */
export function pangramOf(value: unknown): string {
  if (!isRecord(value) || typeof value.pangram !== "string") return "";
  return value.pangram;
}
